var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"gst-event-package-offer-not-available__title"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }